<div class="grid-wrapper" #grid
    [style.width]="gridConfigData.width"
    [style.height]="gridConfigData.height">
  <!-- Render Headers -->
  <div class="header" [style.gridTemplateColumns]="gridTemplateColumns">
    <div class="header-row" *ngFor="let row of headerMerges; let rowIndex = index">
      <div
        *ngFor="let cell of row"
        class="header-cell"
        [ngClass]="{'left': cell.textAlign == 'left' || cell.value[0]?.textAlign == 'left', 'split-cell': cell.value.length > 0}"
        [ngStyle]="{'margin': cell.value[0]?.margin? cell.value[0]?.margin: 'unset', 'align-items': cell?.value[0]?.alignItems? cell.value[0]?.alignItems :'center' }"
        [style.gridColumn]="'span ' + cell.colSpan"
        [style.gridRow]="'span ' + cell.rowSpan"
        [style.height]="(cell.value[0]?.isShowIcon && cell.value[0]?.imgUrl) ? cell.value[0]?.height : (cell.rowSpan * gridConfigData.headerRowHeight) + 'px'">
        <div *ngFor="let val of cell.value"  
          class="cell-value"
          [ngStyle]="{'text-align': val.textAlign ? val.textAlign : 'center', 'padding': val.padding ? val.padding : 'unset'}">
          <div *ngIf=" !val?.useComponent && val?.isShowIcon  && val?.imgUrl">
            <img *ngIf="(cell.value[0]?.isShowIcon  && cell.value[0]?.imgUrl) " 
              [ngStyle]="{'margin-left': (val.title && val.title?.toString()?.length > 1) ? 'unset' : '-4px'}"
              class="cell-ttl-img" src="{{cell.value[0]?.imgUrl}}">
            <span [innerHTML]="val.title"></span>
           
          </div>
          <span *ngIf=" !val?.useComponent && !val?.isShowIcon" 
            [ngStyle]="{ 'font-weight': val?.fontWeight ? val.fontWeight : 'unset'}" [innerHTML]="val.title">
          </span>
          <div *ngIf="val?.useComponent">
              <ng-container *ngIf="componentMap[val.componentSubHeader] as selectedComponent">
                <ng-container *ngComponentOutlet="selectedComponent; inputs:{data: val.data, config: val.configSubHeader}"></ng-container>
              </ng-container>
          </div>
        </div>
      </div>
    </div> 
  </div>
  <div class="grid-body">
    <div class="body-column" [style.gridTemplateColumns]="gridTemplateColumns"
    [ngClass]="{'even-row': rowIndex % 2 === 0, 'odd-row': rowIndex % 2 === 1}"
    *ngFor="let row of bodyData ; let rowIndex = index">
    <!-- Render Body -->
    <ng-container *ngIf="!isGroupData">
      <div
        *ngFor="let cell of row; let colIndex = index"
            class="body-cell"
            [style.border]="gridConfigData.cellBorder"
            [style.gridColumn]="'span ' + cell.columnspan"
            [style.height]="cellHeight"
            [ngClass]="cell.config.cellClass ? cell.config.cellClass : ''"
          >
          <ng-container *ngIf="componentMap[cell.component] as selectedComponent">
            <ng-container *ngComponentOutlet="selectedComponent; inputs:{data: cell.data, config: cell.config, dpadX : '0'  , dpadY: rowIndex }"></ng-container>
          </ng-container>
          <ng-container *ngIf="!componentMap[cell.component] ">
            <div>{{cell.data}}</div>
          </ng-container>
      </div>
    </ng-container>
</div>

<div *ngIf="isGroupData">
  <div *ngFor="let group of groupedData">
    <div class="group-title">
      <label class="grp-lbl" [ngStyle]="groupHeaderStyle">{{ group.groupName }}</label>
      <div class="line-color"></div>
      <div class="grid-body">
        <div class="body-column" [style.gridTemplateColumns]="gridTemplateColumns" 
          [ngClass]="{'even-row': rowIndex % 2 === 0, 'odd-row': rowIndex % 2 === 1}" *ngFor="let row of group.items ?? [] ; let rowIndex = index">    
          <div
          *ngFor="let cell of row; let colIndex = index"
              class="body-cell"
              [style.border]="gridConfigData.cellBorder"
              [style.gridColumn]="'span ' + cell.columnspan"
              [style.height]="cellHeight"
              [ngClass]="cell.config.cellClass ? cell.config.cellClass : ''"
            >
            <ng-container *ngIf="componentMap[cell.component] as selectedComponent">
              <ng-container *ngComponentOutlet="selectedComponent; inputs:{data: cell.data, config: cell.config}"></ng-container>
            </ng-container>
            <ng-container *ngIf="!componentMap[cell.component] ">
              <div>{{cell.data}}</div>
            </ng-container>
        </div>
      </div>
      </div>
      </div>
    </div>  
  </div>
</div>